import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { getCustomerSession } from "../../services/apiCustomer";

export default function useGetCustomerSession() {
  return useQuery({
    queryKey: ["customerSession"],
    queryFn: getCustomerSession,
    staleTime: 20 * 60 * 1000, // 20 minutes
    failedCount: 5, // retry 5 times then show error
    onError: (e) => {
      if (e.response?.data?.detail) toast.error(e.response?.data?.detail);
      else toast.error(e.message);
    },
  });
}
